import { ApplicationState, useAppStore } from '../core/store';
import { NavigationContainer } from '@react-navigation/native';
import React, { useRef } from 'react';
import { useGetUserAttributes, useIsUserLogged } from '../core/hooks/useUser';

import { SafeAreaProvider } from 'react-native-safe-area-context';
import { StatusBar } from 'expo-status-bar';
import { StyleSheet } from 'react-native';
import moment from 'moment';
import { useAnalytics } from '../core/hooks/useAnalytics';
import { useIsFirstRun } from '../core/hooks/useGlobalVar';
import { NavigationLinking } from '../features/navigation/NavConfigForLinking';
import RootNavigation from '../features/navigation/RootNavigation';
import { rootNavigationRef, setNotificationNavigationReady } from '../features/navigation/RootNavigationService';

let oldTime = moment().seconds();

function AppRootView() {
  const theme = useAppStore((state) => state.theme);
  // const viewPortWidth = useAppStore((state) => state.viewPortWidth);

  const { addAnalyticsLog } = useAnalytics('AppRootView.tsx');

  const isFirstRun = useIsFirstRun();
  const isLoggedIn = useIsUserLogged();
  const isInitComplete = useAppStore((state: ApplicationState) => state.isAppInitComplete);
  const userAttributes = useGetUserAttributes();
  const viewPortWidth = useAppStore((state) => state.viewPortWidth);

  // styles
  const styleContainer = StyleSheet.create({
    SafeAreaProvider: {
      flex: 1,
      margin: 'auto',
      width: viewPortWidth
    }
  });
  const routeNameRef = useRef<string | undefined>('');
  const isNavigationReadyForNotifications = isLoggedIn && isInitComplete;

  React.useEffect(() => {
    setNotificationNavigationReady(isNavigationReadyForNotifications);
  }, [isNavigationReadyForNotifications]);

  // view
  return (
    <SafeAreaProvider style={styleContainer.SafeAreaProvider}>
      <NavigationContainer
        linking={NavigationLinking}
        ref={rootNavigationRef as any}
        onReady={() => {
          routeNameRef.current = rootNavigationRef.getCurrentRoute()?.name;
          setNotificationNavigationReady(isNavigationReadyForNotifications);
        }}
        onStateChange={async () => {
          const previousRouteName: string | undefined = routeNameRef.current;
          const currentRouteName: string | undefined = rootNavigationRef.getCurrentRoute()?.name;
          if (previousRouteName !== currentRouteName) {
            // record navigation event in Analytics
            addAnalyticsLog({
              data: {
                currentScreen: currentRouteName,
                previousScreen: previousRouteName,
                username: userAttributes?.name
              },
              logType: 'Navigation'
            });
            // log screen duration
            const duration = moment().seconds() - oldTime;
            addAnalyticsLog({
              data: {
                screen: currentRouteName,
                duration: duration < 0 ? 0 : Number(duration)
              },
              logType: 'Screen'
            });
            oldTime = moment().seconds();
          }

          // Save the current route name for later comparison
          routeNameRef.current = currentRouteName;
        }}>
        {/* <RootStackNavigation isFirstLoad={isFirstRun} isLoggedIn={isLoggedIn && isInitComplete} /> */}
        <RootNavigation isFirstLoad={isFirstRun} isLoggedIn={isLoggedIn && isInitComplete} />
      </NavigationContainer>
      <StatusBar style={theme == 'light' ? 'dark' : 'light'} />
    </SafeAreaProvider>
  );
}

export default AppRootView;
